/**
 * Adhoc Models Export
 */

export * from './adhoc.interface';
